import { ofType } from 'redux-observable';
import {
	switchMap,
	map,
	catchError,
} from 'rxjs/operators';
import { rxjsApiFetcher } from '../../../lib/general-utils';
import {
	actionTypes,
	serviceSettingActions,
	notifyActions,
} from '../../../controller';
import {
	catchErrorForEpics,
} from '../../../../lib/epic-utils';

const {
	START_FETCH_SERVICE_SETTING,
} = actionTypes;
const {
	notifyErrorAction,
} = notifyActions;
const {
	fetchServiceSettingSuccessAction,
	fetchServiceSettingFailedAction,
} = serviceSettingActions;

export function fetchServiceSettingEpic(action$) {
	return action$.pipe(
		ofType(START_FETCH_SERVICE_SETTING),
		switchMap(() =>
			rxjsApiFetcher
				.get('service-setting')
				.pipe(
					map(payload => payload.response),
					map(serviceSetting => fetchServiceSettingSuccessAction(serviceSetting)),
					catchError(error => catchErrorForEpics(error, fetchServiceSettingFailedAction, notifyErrorAction)),
				),
		),
	);
}
